export enum CreditDebitIndication {
  Credit = 0,
  Debit = 1,
}
